import { render, staticRenderFns } from "./MsgElementSeesionScore.vue?vue&type=template&id=49b8158c&scoped=true"
import script from "./MsgElementSeesionScore.vue?vue&type=script&lang=js"
export * from "./MsgElementSeesionScore.vue?vue&type=script&lang=js"
import style0 from "./MsgElementSeesionScore.vue?vue&type=style&index=0&id=49b8158c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8158c",
  null
  
)

export default component.exports